import React from "react";
import "./Sidebar.css";
import { NotAuthorizedAlert } from '../NotAuthorized/NotAuthorized';
import { tr } from '../../../i18n';

const Sidebar = (props) => {

  if (props.pageType === 'TankSidebar') {
    // Add / Delete / Edit tank were removed along with the pump-model code in
    // ATG.js: those modals wrote to `https://${sessionStorage.PumpIp}/v1/tank/`,
    // i.e. straight to a station's LAN address, which is unreachable from this
    // app. Tanks are managed at the station itself. Refresh is what is left.
    return (
      <div className="sidenav">
        <button className="fas fa-sync-alt" onClick={() => window.location.reload(false)} title={tr("Refresh")}></button>
      </div>
    );
  }
  else if (props.pageType === 'ReportsSidebar') {
    return (
      <div className="sidenav">
        <button className="fas fa-filter" onClick={props.showFields} title={tr("Filter Parameters")}></button>
        <button className="sidenav fas fa-print" onClick={() => window.print()} title={tr("Print")}></button>
        <button className="fas fa-eye" id="hideColumnButton" onClick={props.showCheckboxes} title={tr("Hide/View columns")}></button>
        <button className="fas fa-sync-alt" onClick={() => window.location.reload(false)} title={tr("Refresh")}></button>
      </div>
    );
  }
  else if (props.pageType === 'CloseReportsSidebar') {
    return (
      <div className="sidenav">
        <button className="fas fa-sync-alt" onClick={() => window.location.reload(false)} title={tr("Refresh")}></button>
      </div>
    );
  }
  else if (props.pageType === 'CardsSidebar') {
    return (
      <div className="sidenav">
        <button className="fas fa-sync-alt" onClick={() => window.location.reload(false)} title={tr("Refresh")}></button>
      </div>
    );
  }
  else if (props.pageType === 'PeriodicReportsSidebar') {
    return (
      <div className="sidenav">
        <button className="sidenav fas fa-print" onClick={() => window.print()} title={tr("Print")}></button>
        <button className="fas fa-sync-alt" onClick={() => window.location.reload(false)} title={tr("Refresh")}></button>
      </div>
    );
  }
  else if (props.pageType === 'BusesReportsSidebar') {
    // Same minimal pattern as CloseReportsSidebar/CardsSidebar - the page
    // itself already handles station/shift selection and re-fetching on
    // change, so a plain page reload is all this toolbar needs to offer.
    return (
      <div className="sidenav">
        <button className="fas fa-sync-alt" onClick={() => window.location.reload(false)} title={tr("Refresh")}></button>
      </div>
    );
  }
};

export default Sidebar;